import { memo } from 'motion-utils';
var supportsPartialKeyframes = /*@__PURE__*/memo(function () {
  try {
    document.createElement("div").animate({
      opacity: [1]
    });
  } catch (e) {
    return false;
  }

  return true;
});
export { supportsPartialKeyframes };